/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteTemplateAccommodation, fetchODs, fetchTemplatePatterns, searchTemplate } from './actions';
import { getLoading, getTemplateAccomodations } from './selectors';
import GenericGrid from '../grid/GenericGrid/GenericGrid';
import templatesAccommodationsColumns from '../grid/grid-configs/template-accommodations-columns';
import { fetchLocations } from './actions';
import { Button, Form, Modal, Select } from 'antd';
import { TemplateAccommodationStatusEnum } from '../../models/template-accommodation-status-enum';
import AddTemplateDrawer from './AddTemplateDrawer';
import { useMsal } from '@azure/msal-react';
import { PlusOutlined } from '@ant-design/icons';

function TemplatesAccommodations() {
  const dispatch = useDispatch();
  const loading = useSelector(getLoading);
  const gridColumns = templatesAccommodationsColumns ?? [];
  const data = useSelector(getTemplateAccomodations);
  const { Option } = Select;
  const [form] = Form.useForm();
  const [status, setstatus] = useState<string[]>(['PENDING']);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [modalData, setModalData] = useState<any>(null); // <-- Add modalData state
  const [openDelete, setOpenDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const { accounts } = useMsal();
  let loggedInUser = accounts[0]?.name || '';
  let loggedInEmail = accounts[0]?.username || '';

  useEffect(() => {
    dispatch(searchTemplate(status.join(',')));
    dispatch(fetchLocations());
    dispatch(fetchODs());
    dispatch(fetchTemplatePatterns());
  }, []);

  const editDrawer = (record: any) => {
    setModalData(record);
    setIsDrawerOpen(true);
  };

  const deleteTemplate = (record: any) => {
    setDeleteId(record);
    setOpenDelete(true);
  };

  let filterValues = templatesAccommodationsColumns(editDrawer, deleteTemplate, status);

  const onSubmit = (formData) => {
    dispatch(searchTemplate(status.join(',')));
  };

  const handleChange = (values: string[]) => {
    if (values.length === 0) {
      setstatus(['PENDING']);
    } else {
      setstatus(values);
    }
  };

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
    //setModalData(null);
    reloadData();
    setstatus(['PENDING']);
  };

  const reloadData = () => {
    const newStatus = ['PENDING'];
    setstatus(newStatus);
    form.setFieldsValue({ statusFilters: newStatus });
    dispatch(searchTemplate('Pending'));
  };

  const handleDelete = async (e: any) => {
    const deleteData = {
      ID: deleteId,
      ModifiedBy: loggedInUser,
    };
    dispatch(await deleteTemplateAccommodation(deleteData));
    setOpenDelete(false);
    reloadData();
    setDeleteId(null);
  };

  const handleDeleteCancel = (e: any) => {
    setOpenDelete(false);
  };

  const handleDrawerOpen = () => {
    setModalData(null);
    setIsDrawerOpen(true);
  };

  return (
    <>
      <div className='search-container'>
        <Form form={form} layout='vertical' onFinish={(formData) => onSubmit(formData)}>
          <Form.Item
            key='statusFilters'
            label={'Status Filters'}
            name='statusFilters'
            className='label-text input-field'
          >
            <Select
              allowClear
              showArrow
              mode={'multiple'}
              maxTagCount={'responsive'}
              defaultValue={status}
              onChange={(values) => {
                handleChange(values);
                form.setFieldsValue({ statusFilters: values });
              }}
              value={status}
            >
              {Object.entries(TemplateAccommodationStatusEnum).map(([key, label]) => (
                <Option key={key} value={key}>
                  {label}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item className='search-btn'>
            <Button type='primary' htmlType='submit'>
              SEARCH
            </Button>
          </Form.Item>
        </Form>

        {/* Add button outside the form, right aligned */}
        <Form>
          <Form.Item className='search-btn' style={{ marginBottom: '6px' }}>
            <Button
              type='primary'
              htmlType='submit'
              icon={<PlusOutlined />}
              onClick={handleDrawerOpen}
              style={{ borderRadius: '6px' }}
            >
              Add New
            </Button>
          </Form.Item>

          <AddTemplateDrawer open={isDrawerOpen} onClose={handleDrawerClose} modalData={modalData} />
        </Form>
      </div>
      {gridColumns.length > 0 && (
        <GenericGrid
          columns={filterValues}
          data={data}
          enableRowSelection={false}
          rowSelection={[]}
          columnPinning={{}}
          filterDisplayMode='popover'
          highlightFilterMatch={true}
          paginationDisplayMode='pages'
          paginationProps={{
            color: 'primary',
            shape: 'rounded',
            showRowsPerPage: true,
            variant: 'outlined',
            rowsPerPageOptions: [10, 50, 100, 500, 1000],
          }}
          enableStickyHeader={true}
          enableStickyFooter={true}
          enableColumnPinning={true}
          isLoading={loading}
          enableAdd={true}
          enableEditing={isDrawerOpen}
          onAddClick={() => setIsDrawerOpen(true)}
          reloadData={reloadData}
          addDrawerComponent={
            <AddTemplateDrawer open={isDrawerOpen} onClose={handleDrawerClose} modalData={modalData} />
          }
          muiTableBodyCellProps={{
            sx: {
              fontSize: '11px',
              textAlign: 'left',
              fontFamily:
                '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
              padding: '6px 10px',
              height: '40px',
              lineHeight: '1.2',
            },
          }}
          muiTableHeadCellProps={{
            sx: {
              fontSize: '11px',
              fontWeight: 700,
              fontFamily:
                '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
              textAlign: 'center',
              padding: '6px 10px',
              height: '40px',
              lineHeight: '1.2',
            },
          }}
          muiTableBodyRowProps={{
            sx: {
              height: '40px',
              '& td': {
                padding: '6px 10px',
                height: '40px',
              },
              textAlign: 'center',
            },
          }}
        ></GenericGrid>
      )}
      <Modal
        title='Delete template accommodation Confirmation'
        okText='Ok'
        centered
        //confirmLoading={confirmLoading}
        style={{ top: 20 }}
        open={openDelete}
        onOk={(e) => handleDelete(e)}
        onCancel={handleDeleteCancel}
      >
        <span>Are you sure you wish to cancel this request?</span>
      </Modal>
    </>
  );
}

export default TemplatesAccommodations;
